import React from "react";
import { useNavigate } from "react-router-dom";
import { PlusIcon } from "@radix-ui/react-icons";

import { Button } from "@/components/ui";
import { cn } from "@/helpers/tailwind";
import { UrlParams } from "@/constants";
import { useSidebar } from "@/contexts/SidebarContext";

export const CreateBattleButton: React.FC = () => {
  const navigate = useNavigate();
  const { isExpanded } = useSidebar();

  const handleClick = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(UrlParams.CREATE_BATTLE, "true");
    navigate(`/battles?${searchParams.toString()}`);
  };

  return (
    <Button
      variant="secondary"
      className={cn(
        "mb-2 w-full items-center rounded-lg",
        "bg-slate-900 text-slate-900 hover:bg-slate-900",
        {
          "h-9 gap-1 bg-indigo-200 pl-3 pr-2 hover:bg-indigo-200 hover:shadow-xl":
            isExpanded,
        }
      )}
      onClick={handleClick}>
      {isExpanded && (
        <span className="max-w-[124px] truncate font-phonk lg:text-xs">
          Create Battle
        </span>
      )}
      <div
        className={cn(
          "relative rounded-full hover:scale-90",
          "flex flex-shrink-0 items-center justify-center",
          "transition-all duration-300 ease-in-out",
          {
            "size-14 bg-indigo-200": isExpanded,
            "size-12 bg-slate-800": !isExpanded,
          }
        )}>
        <div
          className={cn(
            "relative flex items-center justify-center rounded-full",
            "shadow-[-4px_4px_10px_0px_rgba(0,0,0,0.25)]",
            "bg-[radial-gradient(79.99%_81.44%_at_63.83%_24.47%,#8B85EE_0%,#4F46E5_100%)]",
            {
              "h-11 w-11": isExpanded,
              "h-9 w-9": !isExpanded,
            }
          )}>
          <PlusIcon className="relative size-8 stroke-[2px] text-white" />
        </div>
      </div>
    </Button>
  );
};
